import type { Resource, ResourceType } from '../types/article'

export const resourceFilters: ('All' | `${ResourceType}s`)[] = ['All', 'Guides', 'Templates', 'Checklists']

export const resourceBusinessTypes = [
  'Retail',
  'Food & Beverage',
  'Manufacturing',
  'Services',
  'Hospitality',
  'Healthcare',
  'Other',
]

export const resources: Resource[] = [
  {
    id: 'daily-sales-record',
    type: 'Template',
    title: 'Daily sales record template',
    copy: 'Record every sale and payment method, and total your day in minutes.',
    format: 'Excel',
    size: '45 KB',
  },
  {
    id: 'stock-count-sheet',
    type: 'Template',
    title: 'Stock count sheet',
    copy: 'Count shelf by shelf and spot differences against your records.',
    format: 'Excel',
    size: '38 KB',
  },
  {
    id: 'profit-and-loss',
    type: 'Template',
    title: 'Simple profit and loss template',
    copy: 'Add sales and costs each month to see your real profit.',
    format: 'Excel',
    size: '52 KB',
  },
  {
    id: 'customer-credit-tracker',
    type: 'Template',
    title: 'Customer credit tracker',
    copy: 'Keep track of who owes what, and when they promised to pay.',
    format: 'Excel',
    size: '41 KB',
  },
  {
    id: 'supplier-order-form',
    type: 'Template',
    title: 'Supplier order form',
    copy: 'A clear order form to send to distributors by WhatsApp or email.',
    format: 'Word',
    size: '64 KB',
  },
  {
    id: 'guide-to-going-digital',
    type: 'Guide',
    title: 'Guide to going digital',
    copy: 'A step-by-step plan for moving your shop from notebooks to digital records.',
    format: 'PDF',
    size: '1.2 MB',
  },
  {
    id: 'weekly-expiry-checklist',
    type: 'Checklist',
    title: 'Weekly expiry date checklist',
    copy: 'A 15-minute routine to sell perishable stock before it expires.',
    format: 'PDF',
    size: '220 KB',
  },
  {
    id: 'opening-a-second-branch',
    type: 'Guide',
    title: 'Opening a second branch',
    copy: 'What to plan for stock, staff, and cash before you expand.',
    format: 'PDF',
    size: '980 KB',
  },
  {
    id: 'end-of-day-cash-up',
    type: 'Checklist',
    title: 'End-of-day cash-up checklist',
    copy: 'Match cash, mobile money, and card payments to your sales every evening.',
    format: 'PDF',
    size: '180 KB',
  },
]
